"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var axios_1 = __importDefault(require("axios"));
var material_1 = require("@mui/material");
var Lang_js_1 = require("../Lang.js");
var react_stripe_js_1 = require("@stripe/react-stripe-js");
var LastTransaction_1 = __importDefault(require("./LastTransaction"));
var CheckoutForm = function (props) {
    var _a;
    var stripe = (0, react_stripe_js_1.useStripe)();
    var elements = (0, react_stripe_js_1.useElements)();
    var searchParams = (0, react_router_dom_1.useSearchParams)()[0];
    var _b = (0, react_1.useState)(null), errorMessage = _b[0], setErrorMessage = _b[1];
    var _c = (0, react_1.useState)(false), isProcessing = _c[0], setProcessing = _c[1];
    var _d = (0, react_1.useState)(false), saveCardDisabled = _d[0], setSaveCardDisabled = _d[1];
    var _e = (0, react_1.useState)(false), saveCard = _e[0], setSaveCard = _e[1];
    var _f = (0, react_1.useState)(''), billing_details_name = _f[0], setBillingDetailsName = _f[1];
    var form = document.getElementById('donation-form');
    var imperative_verb = form.getAttribute('imperative_verb').includes('[imperative verb]') ? "Give" : (_a = form.getAttribute('imperative_verb')) !== null && _a !== void 0 ? _a : "Give";
    var studentBillingDetails = { email: searchParams.get("email") };
    var handleBillingDetailsName = function (event) {
        setBillingDetailsName(event.target.value);
    };
    var handleSaveCard = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            event.preventDefault();
            axios_1.default.get('/api/donations/savePaymentMethod?payment_intent_id=' + props.clientSecret.substring(0, 27))
                .then(function (response) {
                if (response.data.status == 'success') {
                    setSaveCard(true);
                    setSaveCardDisabled(true);
                }
            })
                .catch(function (error) {
                console.warn(error);
                setSaveCard(false);
                setSaveCardDisabled(true);
            });
            return [2 /*return*/];
        });
    }); };
    var handleSubmit = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var origin, originParam, the_return_url, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    if (!stripe || !elements) {
                        return [2 /*return*/];
                    }
                    setProcessing(true);
                    if (document.getElementById('billing_details_name') != null && billing_details_name.length == 0) {
                        setErrorMessage((0, Lang_js_1.__)('Please enter your name as it appears on the card'));
                        setProcessing(false);
                        return [2 /*return*/];
                    }
                    if (!(billing_details_name.length > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, axios_1.default.get('/api/donations/updateCustomerName?customer_id=' + props.customerId + '&name=' + encodeURI(billing_details_name))];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    origin = props.origin || new URLSearchParams(window.location.search).get('origin') || '';
                    originParam = origin ? '?origin=' + encodeURIComponent(origin) : '';
                    the_return_url = 'https://' + window.location.hostname + '/app/donate/complete' + originParam;
                    if (window.location.hostname == 'laravel.test') {
                        the_return_url = 'http://' + window.location.hostname + '/app/donate/complete' + originParam;
                    }
                    return [4 /*yield*/, stripe.confirmPayment({
                            elements: elements,
                            confirmParams: {
                                payment_method_data: {
                                    billing_details: {
                                        name: billing_details_name,
                                    },
                                },
                                return_url: the_return_url
                            }
                        })];
                case 3:
                    error = (_a.sent()).error;
                    if (error) {
                        setProcessing(false);
                        setErrorMessage(error.message);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(material_1.Card, { elevation: 0 },
        react_1.default.createElement(material_1.CardContent, { sx: { px: 2, py: 1, '&:last-child': { pb: 1 } } },
            react_1.default.createElement("form", { onSubmit: handleSubmit },
                !props.loggedIn &&
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(material_1.InputLabel, { htmlFor: "billing_details_name", required: true }, (0, Lang_js_1.__)('Name on card')),
                        react_1.default.createElement(material_1.Input, { id: "billing_details_name", type: "text", required: true, onChange: handleBillingDetailsName, sx: { width: 1 }, disableUnderline: true, autoComplete: "off" })),
                react_1.default.createElement(react_stripe_js_1.LinkAuthenticationElement, { id: "linkAuthentication" }),
                react_1.default.createElement(react_stripe_js_1.PaymentElement, { options: { fields: { billingDetails: { name: 'never' } }, defaultValues: { billingDetails: studentBillingDetails } }, id: "paymentElement" }),
                props.loggedIn &&
                    react_1.default.createElement("div", { className: "StripeElement" },
                        react_1.default.createElement(material_1.FormControlLabel, { control: react_1.default.createElement(material_1.Checkbox, { checked: saveCard, disabled: saveCardDisabled, onChange: handleSaveCard, inputProps: { autoComplete: "off" } }), label: (0, Lang_js_1.__)("Securely save this card for next time"), sx: { mt: 1, mb: 1 } })),
                errorMessage && react_1.default.createElement(material_1.Alert, { severity: "error" }, errorMessage),
                react_1.default.createElement(material_1.Button, { type: "submit", disabled: !stripe || isProcessing, variant: "contained", fullWidth: true, size: "large", sx: { p: 1, mt: 1, mb: 1, maxWidth: 480 }, id: "submitButton" }, (0, Lang_js_1.__)(imperative_verb)),
                props.loggedIn && props.origin !== 'subscription-cart' &&
                    react_1.default.createElement(LastTransaction_1.default, { displayType: "info" }),
                react_1.default.createElement(material_1.Modal, { open: isProcessing, onClose: function () { return; }, "aria-labelledby": "modal-modal-title", "aria-describedby": "modal-modal-description" },
                    react_1.default.createElement(material_1.Box, { display: "flex", width: "100%", height: "100%", justifyContent: "center", alignItems: "center", bgcolor: "white" },
                        react_1.default.createElement("div", { id: "modal-modal-title", style: { display: 'flex', justifyContent: 'center' } },
                            react_1.default.createElement(material_1.CircularProgress, null)),
                        react_1.default.createElement("div", { style: { display: 'flex', justifyContent: 'center', minHeight: '3rem', marginLeft: '1rem' } },
                            react_1.default.createElement(material_1.Typography, { id: "modal-modal-description", sx: { mt: 2 } }, (0, Lang_js_1.__)("Please wait...")))))))));
};
exports.default = CheckoutForm;
